<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
    <g>
      <path
        d="M11.159,33.806c-9.006-3.502-13.466-13.64-9.966-22.648C4.696,2.153,14.837-2.309,23.841,1.196
		c9.006,3.499,13.466,13.643,9.966,22.646C30.304,32.848,20.163,37.307,11.159,33.806"
      />
      <g>
        <path
          fill="#FFFFFF"
          d="M21.468,18.511c-0.04,0.015-0.247,0.153-0.413,0.265c-0.661,0.446-1.893,1.275-3.555,1.275
			s-2.894-0.829-3.555-1.275c-0.166-0.112-0.373-0.25-0.438-0.268c-3.051,0.003-3.511,3.794-3.511,6.054
			c0,1.586,1.02,2.572,2.659,2.572h9.689c1.64,0,2.659-0.985,2.659-2.572C25.004,22.302,24.544,18.511,21.468,18.511z"
        />
        <path
          fill="#FFFFFF"
          d="M11.114,12.943c1.4,0,2.539-1.138,2.539-2.538c0-1.399-1.139-2.537-2.539-2.537
			c-1.398,0-2.537,1.138-2.537,2.537C8.577,11.805,9.716,12.943,11.114,12.943z"
        />
        <path
          fill="#FFFFFF"
          d="M27.678,14.868c-0.18-0.878-0.485-1.324-0.91-1.324c-0.005,0.008-0.148,0.085-0.264,0.147
			c-0.514,0.278-1.47,0.795-2.618,0.795c-0.384,0-0.757-0.046-1.131-0.14c0.008,0.11,0.011,0.215,0.011,0.316
			c0,0.891-0.24,1.791-0.684,2.582c0.993,0.143,1.885,0.62,2.561,1.376h1.349c0.895,0,1.851-0.384,1.851-1.463
			C27.842,16.637,27.843,15.681,27.678,14.868z"
        />
        <path
          fill="#FFFFFF"
          d="M17.5,10.706c-2.182,0-3.957,1.774-3.957,3.957s1.775,3.958,3.957,3.958s3.957-1.775,3.957-3.958
			S19.682,10.706,17.5,10.706z"
        />
        <path
          fill="#FFFFFF"
          d="M23.886,12.943c1.398,0,2.537-1.138,2.537-2.538c0-1.399-1.139-2.537-2.537-2.537
			c-1.4,0-2.539,1.138-2.539,2.537C21.347,11.805,22.485,12.943,23.886,12.943z"
        />
        <path
          fill="#FFFFFF"
          d="M7.158,17.096c0,1.14,0.956,1.524,1.851,1.524h1.349c0.676-0.756,1.567-1.233,2.561-1.376
			c-0.443-0.791-0.684-1.69-0.684-2.582c0-0.101,0.003-0.206,0.011-0.316c-0.374,0.094-0.747,0.14-1.131,0.14
			c-1.148,0-2.104-0.517-2.618-0.795c-0.115-0.062-0.259-0.14-0.302-0.152c-0.387,0.004-0.692,0.45-0.872,1.328
			C7.157,15.681,7.158,16.637,7.158,17.096z"
        />
      </g>
    </g>
  </svg>
</template>
